import { Component, OnInit, ViewChild } from '@angular/core';
import { VenderService } from './vendorService.service';
import { Vendor } from '../../../model/Vendor';
import { UntypedFormGroup, FormBuilder, NgForm, UntypedFormControl } from '@angular/forms';
import { NgbModalOptions } from '@otas/modal/modal';
import { NgbModalRef,NgbActiveModal } from '@otas/modal/modal-ref';
import { NgbModal } from '@otas/modal/modal';
@Component({
    selector: 'app-vendor',
    templateUrl: './vendor.component.html',
    styleUrls: ['./vendor.component.css'],
    providers: [VenderService],
    standalone: false
})
export class VendorComponent implements OnInit {
  modalrefer: NgbModalRef;
  vendor: Vendor[] = [];
  newVendor: UntypedFormGroup;
  heading;
  data;
  submitted = false;
  @ViewChild('content', { static: false }) content: string;
  closeResult: string;
  person: String;

  mediumModalOptions: NgbModalOptions = {
    windowClass: 'animated fadeInDown', backdrop: 'static', size: 'lg'
  };
  constructor(private modalService: NgbModal, public activeModal: NgbActiveModal,
    private venderService: VenderService) {
    this.newVendor = new UntypedFormGroup({
      name: new UntypedFormControl(''),
      address: new UntypedFormControl(''),
      phone: new UntypedFormControl(''),
      email: new UntypedFormControl(''),
      type: new UntypedFormControl(''),
      id: new UntypedFormControl('')
    });
  }

  ngOnInit() {

    this.getAllVendor();
    if (!!this.data) {
      this.newVendor.patchValue(this.data);
    }
  }
  open(content) {
    this.modalrefer = this.modalService.open(content, this.mediumModalOptions);

  }
  vendorFormValidation(vendorObject) {
    if (this.newVendor.invalid) {
      this.submitted = true;
      return;
    }
  }
  checkSaveEdit() {
    if (this.newVendor.invalid) {
      this.submitted = true;
      return;
    }
    if (this.newVendor.get('id').value) {
      this.editVendor(this.newVendor.value);
    } else {
      this.addVendor(this.newVendor.value);
    }
  }
  addVendor(vendorObject) {
    this.venderService.saveVendor(this.newVendor.value).subscribe((response) => {

      if (response.status === 'SUCCESS') {
        this.activeModal.close(true);
        // this.getAllVendor();
      }
    });
  }
  editVendor(vendorObject) {
    this.newVendor.patchValue(vendorObject);
    this.venderService.editOldVendor(this.newVendor.value).subscribe((response) => {
      if (response.status === 'SUCCESS') {
        // this.open(this.content);
        this.activeModal.close(true);
        // this.getAllVendor();
      }
    });

  }

  deleteVendor(vendorObject) {
    this.vendor.splice(this.vendor.indexOf(vendorObject), 1);
    // this.venderService.deleteOldVendor(vendorObject ).subscribe((response)=>{
    //   console.log(response);
    //  });

  }

  getAllVendor(): void {
    this.venderService.getAllVendors().subscribe((response) => {
      // console.log(response);
      this.vendor = response.result;
    });
  }
}
